import React from "react";
import styled from "styled-components";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { getCarryOverReasons } from '../util'
import ListItem from '@material-ui/core/ListItem'
import Icon from '@material-ui/core/Icon';

const NoteTitle = styled.h2`
  margin: 20px 0px;
`;

const NoteLabel = styled.span`
  font-weight: bold;
  align-self: flex-start;
  margin: 16px 0px 0px 0px;
`;

const Note = styled.div`
  background: #eff2f9;
  border: none;
  border-radius: 16px;
  font-family: 'DM Sans', sans-serif;
  font-size: 1rem;
  margin-top: 4px;
  max-width: 500px;
  width: 100%;
  padding: 16px;
  white-space: pre-line;
`;

export const CarryOverModal = ({open, onClose, data}) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={() => onClose()}
      >
        {data &&
          <DialogContent className="avn-modal-content-container">
            {data &&
              <>
                <NoteTitle>Why macros were kept</NoteTitle>
                {getCarryOverReasons(data.goal).map((reason, index) => (reason[0]) !== 0 &&
                  <ListItem key={reason[0]}>
                    <Icon className='material-icons' id={'carry-over-reason-checkbox-' + reason[0]} style={{ color: (data.reason_code & reason[0]) ? '#14ab40' : '#5a5a5a'}}>
                      {(data.reason_code & reason[0]) ? 'check_circle' : 'radio_button_unchecked'}
                    </Icon>
                    <span className='carry-over-reason-text'>{reason[1]}</span>
                  </ListItem>
                )}
                {data.reason_text &&
                  <>
                    <NoteLabel>Note:</NoteLabel>
                    <Note>
                      {data.reason_text}
                    </Note>
                  </>
                }
              </>
            }
          </DialogContent>
        }
        <DialogActions className='avn-modal-actions-container'>
          <button
            className="avn-modal-action"
            onClick={() => onClose()}
          >
            Close
          </button>
        </DialogActions>
      </Dialog>
    </>
  )
}

